import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const titles = {
  server: 'Oops! Something went terribly wrong.',
  generic: 'An error occured.',
};

const getText = e => {
  if (e && e.response) {
    if (e.response.status >= 500) {
      return {
        title: titles.server,
        message: e.response.data && e.response.data.message,
      };
    }
  }

  return { title: titles.generic };
};

const Presenter = props => {
  const { open, httpError, handleClose } = props;
  const { title, message } = getText(httpError);

  return (
    <Dialog
      aria-labelledby="error-dialog-title"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle id="error-dialog-title">{title}</DialogTitle>
      {message && (
        <DialogContent>
          <ExpansionPanel elevation={1}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">Technical details</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <DialogContentText>{message}</DialogContentText>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </DialogContent>
      )}
      <DialogActions>
        <Button
          onClick={handleClose}
          autoFocus
          color="primary"
          variant="contained"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Presenter;
